module.exports = __webpack_public_path__ + "static/media/qnb_logo@3x.59d21b13.png";